import { createTheme } from '@dentalux/ui-library-core/constants';
import { palette } from '@dentalux/ui-library-core/constants';
import { MuiAlert } from '@dentalux/ui-library-core/themes';
import { MuiButton } from '@dentalux/ui-library-core/themes';
import { MuiFormHelperText } from '@dentalux/ui-library-core/themes';
import { shadows } from '@dentalux/ui-library-core/themes';
import { MuiTypography, typography } from '@dentalux/ui-library-core/themes';
import MuiAccordion from './overrides/MuiAccordion';
import MuiCssBaseline from './overrides/MuiCssBaseline';
import MuiDivider from './overrides/MuiDivider';
import MuiFilledInput from './overrides/MuiFilledInput';
import MuiInputBase from './overrides/MuiInputBase';
import MuiInputLabel from './overrides/MuiInputLabel';
import MuiLink from './overrides/MuiLink';
import MuiListItemIcon from './overrides/MuiListItemIcon';
import MuiMenu from './overrides/MuiMenu';
import MuiMenuItem from './overrides/MuiMenuItem';
import MuiPaper from './overrides/MuiPaper';
import MuiRating from './overrides/MuiRating';
import MuiTab from './overrides/MuiTab';
import MuiTabs from './overrides/MuiTabs';
import MuiTooltip from './overrides/MuiTooltip';
const theme = createTheme({
  shadows,
  typography,
  components: {
    MuiTypography,
    MuiPaper,
    MuiTab,
    MuiTooltip,
    MuiTabs,
    MuiAccordion,
    MuiMenuItem,
    MuiInputBase,
    MuiInputLabel,
    MuiFilledInput,
    MuiFormHelperText,
    MuiListItemIcon,
    MuiAlert,
    MuiLink,
    MuiRating,
    MuiMenu,
    MuiDivider,
    MuiButton,
    MuiCssBaseline
  },
  palette
});
export default theme;